"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBureau = exports.bureauSlugs = exports.bureaus = void 0;
const case_insensitive_includes_1 = require("./case-insensitive-includes");
const dnbCommonBusinessScoreModel = {
    bureauIdentifier: 'dnb',
    type: 'Business',
    label: 'D-U-N-S® Number',
    scoreDifferentUrl: 'https://www.nav.com/business-credit-scores/dun-bradstreet-paydex/',
    scores: { minScore: 0, maxPoor: 34, maxFair: 69, maxGood: 100 },
    grades: { minScore: 1, F: 8, C: 11, B: 14, A: 17, maxGood: 17 },
    gradeColor: {
        F: 'poor',
        C: 'semipoor',
        B: 'fair',
        A: 'good',
    },
};
const xpnCommonBusinessScoreModel = {
    bureauIdentifier: 'xpn',
    type: 'Business',
    label: 'BIN',
    scoreDifferentUrl: 'https://www.nav.com/business-credit-scores/faq/',
    grades: { minScore: 1, F: 8, C: 11, B: 14, A: 17, maxGood: 17 },
    gradeColor: {
        F: 'poor',
        C: 'semipoor',
        B: 'fair',
        A: 'good',
    },
};
const eqxCommonBusinessScoreModel = {
    bureauIdentifier: 'eqx',
    type: 'Business',
    label: '',
    scoreDifferentUrl: 'https://www.nav.com/business-credit-scores/faq/',
    scores: {
        minScore: 224,
        maxPoor: 400,
        maxFair: 448,
        maxGood: 580,
    },
    grades: { minScore: 224, F: 366, D: 400, C: 448, B: 484, A: 580, maxGood: 580 },
    gradeColor: {
        F: 'poor',
        D: 'semipoor',
        C: 'fair',
        B: 'semigood',
        A: 'good',
    },
};
const vantageScore = {
    reportableType: 'VantageScore® 3.0',
    label: 'Vantage 3.0',
    scoreDifferentUrl: 'https://www.nav.com/blog/why-are-my-credit-scores-different-1224/',
    explanation: {
        header: 'What is VantageScore?',
        copy: 'VantageScore was founded in 2006 by three major credit bureaus—TransUnion, Equifax and Experian. They wanted to create a credit scoring model that competed with the popular FICO models while also expanding credit scoring reach. In short, they wanted to help more people qualify for a credit score.',
    },
};
exports.bureaus = [
    // Dun & Bradstreet
    {
        displayName: 'Dun & Bradstreet®',
        slug: 'dnb',
        aliases: ['dandb'],
        scoreModels: [
            Object.assign(Object.assign({}, dnbCommonBusinessScoreModel), { aliases: ['dun_and_bradstreet_reports', 'paydex'], reportableType: 'PAYDEX®', explanation: {
                    header: 'What is the Dun & Bradstreet PAYDEX® Score?',
                    copy: `The PAYDEX® Score is generated by Dun & Bradstreet and operates on a scale of 1-100. The model
        analyzes a business’s payment performance (i.e. if your business pays bills on time) and
        payment history is the most important factor in the score. A score above 80 reflects a
        near-perfect payment history.`,
                } }),
            Object.assign(Object.assign({}, dnbCommonBusinessScoreModel), { aliases: ['dun_and_bradstreet_report_summaries', 'summary', 'freemium'], reportableType: 'Business Risk Grade' }),
        ],
    },
    // Experian
    {
        displayName: 'Experian®',
        slug: 'xpn',
        aliases: ['experian'],
        scoreModels: [
            Object.assign(Object.assign({}, xpnCommonBusinessScoreModel), { aliases: [
                    'experian_business_reports',
                    'intelliscore',
                    'intelliscore plus',
                    'intelliscore plus v2',
                    'experian business',
                    'experian® business',
                ], reportableType: 'Intelliscore Plus℠ V2', explanation: {
                    header: 'What is the Experian Intelliscore Plus℠ V2 Score?',
                    copy: `Using both personal and business credit data, the Intelliscore is a good measure of your
    business’s overall credit health. The higher your Intelliscore, the lower a risk you seem to
    business lenders and other creditors. Payment history, as well as utilization and trended
    data, are important factors in this score.`,
                }, scores: { minScore: 0, maxPoor: 24, maxFair: 74, maxGood: 100 } }),
            Object.assign(Object.assign({}, xpnCommonBusinessScoreModel), { reportableType: 'Business Risk Grade', aliases: ['experian_business_report_summaries', 'summary', 'freemium'], scores: { minScore: 1, maxPoor: 8, maxFair: 14, maxGood: 17 } }),
            Object.assign(Object.assign({ bureauIdentifier: 'xpn' }, vantageScore), { type: 'Personal', aliases: ['experian_ppq_summary_reports', 'experian_personal_reports', 'scorex', 'vantage', 'vantage_3_0'], scores: { minScore: 300, maxPoor: 579, maxFair: 679, maxGood: 850 }, grades: { minScore: 0, F: 50, C: 70, B: 80, A: 100, maxGood: 100 }, gradeColor: {
                    F: 'poor',
                    C: 'semipoor',
                    B: 'fair',
                    A: 'good',
                } }),
        ],
    },
    // Equifax
    {
        displayName: 'Equifax®',
        slug: 'eqx',
        aliases: ['equifax'],
        scoreModels: [
            Object.assign(Object.assign({}, eqxCommonBusinessScoreModel), { aliases: ['equifax_report_summaries', 'equifax_report_premium', 'business delinquency score'], reportableType: 'Business Delinquency Score™', explanation: {
                    header: 'What is the Equifax Business Delinquency Score?',
                    copy: `Based on a scale of 224-580, the Delinquency Risk Score measures how likely you are to become delinquent on your business tradelines and accounts. The higher your score, the better. Equifax data can include utilities and telecom accounts for your business, as well as other net terms tradelines and public filings.`,
                } }),
            Object.assign(Object.assign({}, eqxCommonBusinessScoreModel), { aliases: ['equifax_report_summaries', 'summary', 'freemium'], reportableType: 'Business Risk Grade' }),
        ],
    },
    // TransUnion
    {
        displayName: 'TransUnion®',
        slug: 'txu',
        aliases: ['transunion'],
        scoreModels: [
            Object.assign(Object.assign({ bureauIdentifier: 'txu' }, vantageScore), { type: 'Personal', aliases: ['transunion_personal_reports', 'vantage', 'vantage_3_0'], scores: { minScore: 300, maxPoor: 579, maxFair: 679, maxGood: 850 } }),
        ],
    },
    // FICO
    {
        displayName: 'FICO®',
        slug: 'fico',
        aliases: [],
        scoreModels: [
            {
                bureauIdentifier: 'fico',
                type: 'Business',
                aliases: ['fico_business_reports', 'liquidcredit'],
                reportableType: 'Small Business Scoring Service℠',
                shortReportableType: 'SBSS℠',
                label: '',
                scoreDifferentUrl: 'https://www.nav.com/business-credit-scores/fico-sbss/',
                explanation: {
                    header: 'What is the FICO® SBSS℠ Score?',
                    copy: `This score is used by the U.S. Small Business Administration (SBA) and many commercial lenders in their loan underwriting process to determine a small business's creditworthiness`,
                },
                scores: {
                    minScore: 0,
                    maxPoor: 149,
                    maxFair: 169,
                    maxGood: 300,
                },
            },
        ],
    },
];
exports.bureauSlugs = exports.bureaus.map(({ slug }) => slug);
const getBureau = (identifier) => {
    return identifier
        ? exports.bureaus.find((bureau) => (0, case_insensitive_includes_1.caseInsensitiveIncludes)([bureau.slug, bureau.displayName, ...bureau.aliases], identifier))
        : undefined;
};
exports.getBureau = getBureau;
//# sourceMappingURL=bureaus.js.map